export default "__VITE_ASSET__BhDiJrRd__"